import { render, staticRenderFns } from "./ddzhtj.vue?vue&type=template&id=6de4112a&scoped=true&"
import script from "./ddzhtj.vue?vue&type=script&lang=js&"
export * from "./ddzhtj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de4112a",
  null
  
)

export default component.exports